import * as React from 'react';

import {ActionMenu} from '../action-menu/action-menu';
import {IconOnlyButton} from '../button/icon-only-button/icon-only-button';
import {Card} from '../card/card';
import {colors} from '../colors/colors';
// @ts-expect-error
import {SelectMenuOption} from '../select-menu/select-menu';

import styles from './toolbar.module.css';

export type ToolbarOption =
    | {
          id: string;
          icon: React.ComponentType<any>;
          onClick: () => any;
          tooltipText: string;
          isDisabled?: boolean;
          getRef?: (arg1?: HTMLElement | null | undefined) => void;
          domId?: string;
      }
    | {
          // For cases where option is more complex than an icon
          component: React.ReactNode;
          id: string;
      };

export type ActionMenuOptions = {
    options: SelectMenuOption[];
    getRef?: (arg1?: HTMLElement | null | undefined) => void;
};

export type Props = {
    options: ToolbarOption[];
    actionMenuOptions?: ActionMenuOptions;
};

/**
 * This component is designed around the new style of icons which have square viewboxes
 * and where the icon doesn't visibly reach the edge of the viewbox.
 */
export function Toolbar(props: Props) {
    return (
        <Card
            hasBorder={true}
            fitContent={true}
            borderColor={colors.buttonSecondaryDk}
            hasShadow={true}
        >
            <div
                className='flex py-4 px-6 align-center gap-8'
                onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                }}
            >
                {props.options.length > 0 &&
                    props.options.map((option) => {
                        // @ts-expect-error
                        if (option.icon) {
                            return (
                                <IconOnlyButton
                                    // @ts-expect-error
                                    id={option.domId}
                                    key={option.id}
                                    // @ts-expect-error
                                    icon={option.icon}
                                    // @ts-expect-error
                                    onClick={() => option.onClick()}
                                    // @ts-expect-error
                                    tooltipText={option.tooltipText}
                                    // @ts-expect-error
                                    isDisabled={option.isDisabled}
                                    // @ts-expect-error
                                    getButtonRef={option.getRef}
                                />
                            );
                        }

                        return (
                            // @ts-expect-error
                            option.component && ( // @ts-expect-error
                                <React.Fragment key={option.id}>{option.component}</React.Fragment>
                            )
                        );
                    })}
                {props.actionMenuOptions && (
                    <div className={styles['action-menu-container']}>
                        <ActionMenu
                            size='tiny'
                            hasHoverBackground={true}
                            hasDarkHoverBackground={true}
                            options={props.actionMenuOptions.options}
                            getRef={props.actionMenuOptions.getRef}
                        />
                    </div>
                )}
            </div>
        </Card>
    );
}
